import { SVGProps } from 'react';

export const Duplicate = (props: SVGProps<any>) => (
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>duplicate</title>
    <g
      id="Rectangle"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g>
        <rect x="0" y="0" width="32" height="32" />
        <g>
          <polygon points="22.6851485 7.98415842 22.6851485 1.86930693 1.86930693 1.86930693 1.86930693 22.6534653 7.98415842 22.6534653 7.98415842 7.98415842" />
          <path
            d="M24.2693069,7.98415842 L24.2693069,0.285148515 L0.285148515,0.285148515 L0.285148515,24.2376238 L7.98415842,24.2376238 L7.98415842,31.9366337 L31.9366337,31.9366337 L31.9366337,7.98415842 L24.2693069,7.98415842 Z M7.98415842,22.6534653 L1.86930693,22.6534653 L1.86930693,1.86930693 L22.6534653,1.86930693 L22.6534653,7.98415842 L7.98415842,7.98415842 L7.98415842,22.6534653 Z M30.3524752,30.3841584 L9.56831683,30.3841584 L9.56831683,24.2376238 L9.56831683,22.6534653 L9.56831683,9.56831683 L22.6851485,9.56831683 L24.2693069,9.56831683 L30.3841584,9.56831683 L30.3841584,30.3841584 L30.3524752,30.3841584 Z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </g>
    </g>
  </svg>
);
